import { createContext, useContext, useEffect, useState, useCallback, useMemo } from "react";
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
axios.defaults.withCredentials = true;

const AuthCtx = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);       // null | user object
  const [loading, setLoading] = useState(true);

  const checkAuth = useCallback(async () => {
    // Skip if returning from OAuth callback — AuthCallback handles it
    if (window.location.hash?.includes("session_id=")) { setLoading(false); return; }
    try {
      const { data } = await axios.get(`${API}/auth/me`);
      setUser(data);
    } catch (e) { setUser(false); console.debug("auth check failed", e?.response?.status || e?.message); }
    finally { setLoading(false); }
  }, []);

  useEffect(() => { checkAuth(); }, [checkAuth]);

  const login = async (email, password) => {
    const { data } = await axios.post(`${API}/auth/login`, { email, password });
    setUser(data); return data;
  };
  const register = async (email, password, name) => {
    const { data } = await axios.post(`${API}/auth/register`, { email, password, name });
    setUser(data); return data;
  };
  const logout = async () => {
    try { await axios.post(`${API}/auth/logout`); } catch (e) { console.debug("logout failed", e?.message); }
    setUser(false);
  };
  const startGoogle = () => {
    // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
    const redirect = window.location.origin + "/";
    window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirect)}`;
  };

  const value = useMemo(
    () => ({ user, loading, login, register, logout, startGoogle, refresh: checkAuth, setUser }),
    [user, loading, checkAuth]
  );

  return (
    <AuthCtx.Provider value={value}>
      {children}
    </AuthCtx.Provider>
  );
}

export const useAuth = () => useContext(AuthCtx);

export function formatApiError(detail) {
  if (detail == null) return "Something went wrong.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) return detail.map(e => e?.msg || JSON.stringify(e)).join(" ");
  return String(detail);
}
